import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { useAddCallStatusMutation, useUpdateCallStatusMutation } from "./Api";
import ToastrService from "../../services/toastService";
import Loader from "../loader/loader"
import { Logout, shouldLogout } from '../Common/Common'
import { useNavigate } from "react-router-dom";

const ManageCallStatus = ({
    mode = "add",
    onClose,
    onSave,
    data = null,
}) => {

    const [addCallStatusApi, { isLoading }] = useAddCallStatusMutation()
    const [updateCallStatusApi, { isLoading: updateIsLoading }] = useUpdateCallStatusMutation()

    const navigate = useNavigate()

    const validationSchema = Yup.object().shape({
        statusName: Yup.string()
            .required('Status Name is required')
            .matches(/^[A-Za-z ]+$/,
                "Enter valid Status Name")
            .trim(),
        description: Yup.string()
            .transform((value) => (value === "" ? null : value)) // handle empty string
            .nullable()
            .notRequired(),
        colour: Yup.string()
            .required('Colour is required')
            .trim(),
        alert_message: Yup.string()
            .required('Alert message is required')
            .trim(),
        status: Yup.string()
            .required('Status is required')
            .trim(),
    });

    const { register, handleSubmit, reset, watch, formState: { errors } } = useForm({
        resolver: yupResolver(validationSchema),
        mode: 'all',
    });

    useEffect(() => {
        if (data) {
            // console.log(data, 'dataaaaa')
            reset({
                statusName: data.statusName,
                description: data.description,
                colour: data.colour,
                alert_message: data.alert_message,
                status: data.status,
            });
        }
    }, [])

    const resetButton = () => {
        reset({
            statusName: "",
            description: "",
            colour: "",
            alert_message: "",
            status: "",
        });
    };

    const onSubmit = async (payload) => {
        try {
            if (mode == 'add') {

                const data = {
                    statusName: payload.statusName,
                    description: payload.description,
                    colour: payload.colour,
                    alert_message: payload.alert_message,
                    status: payload.status,
                }

                const response = await addCallStatusApi(data)

                if (response?.data?.success) {
                    ToastrService.success(response?.data?.message);
                    reset()
                    onSave()
                } else {

                    if (shouldLogout(response.error)) {
                        Logout(navigate);
                        return
                    }

                    ToastrService.error(response.error.data.message);
                }

            } else {

                const updateData = {
                    statusName: payload.statusName,
                    description: payload.description,
                    colour: payload.colour,
                    alert_message: payload.alert_message,
                    status: payload.status,
                    id: data.id,
                }
                const response = await updateCallStatusApi(updateData)

                if (response?.data?.success) {
                    ToastrService.success(response?.data?.message);
                    reset()
                    onSave()
                } else {

                    if (shouldLogout(response.error)) {
                        Logout(navigate);
                        return
                    }

                    ToastrService.error(response.error.data.message);
                }
            }
        } catch (err) {
            console.log(err, 'err')
        }
    }

    return (
        <div>
            {isLoading || updateIsLoading ? <Loader /> :
                <>
                    <div className="offcanvas offcanvas-end show" style={{ visibility: "visible" }} tabIndex="-1">

                        <div className="offcanvas-header px-4 py-3">

                            <div>
                                <h3 className="mb-1 drawer-header">
                                    {mode === "add" ? "Add Status" : "Manage Status"}
                                </h3>
                                <small className="text-muted">{mode === "add" ? "Fill in the details below to create a New Status." : "Update the details below to Manage Status"}</small>
                            </div>

                            <button
                                type="button"
                                className="btn-close text-reset"
                                onClick={onClose}
                                aria-label="Close"
                            ></button>

                        </div>


                        <div className="offcanvas-body px-4 py-3">

                            <form autoComplete="off" noValidate onSubmit={handleSubmit(onSubmit)}>

                                <div className="mb-3">
                                    <label className="form-label">
                                        Status Name <span className="text-danger">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        id="statusName"
                                        name='statusName'
                                        placeholder='Enter the Status name'
                                        {...register('statusName')}
                                        className="form-control"

                                    />
                                    {errors.statusName && (
                                        <p className="mt-2" style={{ color: "#d93025", fontFamily: "revert", marginLeft: '1%' }}>
                                            {errors.statusName.message}
                                        </p>
                                    )}
                                </div>

                                <div className="mb-3">
                                    <label className="form-label">
                                        Description
                                    </label>
                                    <textarea
                                        id="description"
                                        placeholder="Brief description of the Status..."
                                        name='description'
                                        {...register('description')}
                                        className="description-input"
                                    />
                                    {errors.description && (
                                        <p className="mt-1" style={{ color: "#d93025", fontFamily: "revert", marginLeft: '1%' }}>
                                            {errors.description.message}
                                        </p>
                                    )}
                                </div>
                                {/* 
                                <div className="mb-3">
                                    <label className="form-label">
                                        Colour <span className="text-danger">*</span>
                                    </label>
                                    <select
                                        id="colour"
                                        name="colour"
                                        {...register('colour')}
                                        className="custom-select"
                                    >
                                        <option value="">Select colour</option>
                                        {options.map((opt) => (
                                            <option key={opt.value} value={opt.value}>
                                              {opt.icon}  {opt.label}
                                            </option>
                                        ))}
                                    </select>
                                    {errors.colour && (
                                        <p className="mt-2" style={{ color: "#d93025", fontFamily: "revert", marginLeft: '1%' }}>
                                            {errors.colour.message}
                                        </p>
                                    )}

                                </div> */}

                                {/* <div className="mb-4">
                                    <label className="form-label fw-semibold">
                                        Colour <span className="text-danger">*</span>
                                    </label>

                                    <div
                                        className="d-flex align-items-center gap-3 p-3 rounded"
                                        style={{
                                            border: "1px solid #e5e7eb",
                                            background: "#fff",
                                            flexWrap: "wrap",
                                        }}
                                    >
                                 
                                        <input
                                            type="color"
                                            {...register("colour")}
                                            className="form-control form-control-color"
                                            style={{
                                                width: "60px",
                                                height: "45px",
                                                cursor: "pointer",
                                                border: "none",
                                                padding: 0,
                                                background: "transparent",
                                            }}
                                            title="Choose color"
                                        />

                                     
                                        <div className="flex-grow-1">
                                            <div
                                                style={{
                                                    fontSize: "13px",
                                                    color: "#6b7280",
                                                    marginBottom: "4px",
                                                }}
                                            >
                                                Selected Color
                                            </div>

                                            <div
                                                style={{
                                                    fontWeight: 600,
                                                    fontSize: "14px",
                                                    fontFamily: "monospace",
                                                }}
                                            >
                                                {watch("colour") || "#000000"}
                                            </div>
                                        </div>

                                      
                                        <div className="text-center">
                                            <div
                                                style={{
                                                    fontSize: "12px",
                                                    color: "#6b7280",
                                                    marginBottom: "4px",
                                                }}
                                            >
                                                Preview
                                            </div>

                                            <div
                                                style={{
                                                    width: "45px",
                                                    height: "45px",
                                                    borderRadius: "10px",
                                                    border: "1px solid #ddd",
                                                    backgroundColor: watch("colour") || "#000000",
                                                }}
                                            />
                                        </div>
                                    </div>

                              
                                    {errors.colour && (
                                        <p
                                            className="mt-2"
                                            style={{
                                                color: "#d93025",
                                                fontSize: "13px",
                                                marginLeft: "2px",
                                            }}
                                        >
                                            {errors.colour.message}
                                        </p>
                                    )}
                                </div> */}

                                <div className="mb-4">
                                    <label className="form-label fw-semibold color-label">
                                        Colour <span className="text-danger">*</span>
                                    </label>

                                    <div className="d-flex align-items-center gap-3 p-3 rounded color-picker-box">

                                        {/* Color Input */}
                                        <input
                                            type="color"
                                            {...register("colour")}
                                            className="form-control form-control-color color-input"
                                            title="Choose color"
                                        />

                                        {/* Selected Color Info */}
                                        <div className="flex-grow-1">
                                            <div className="color-subtext">Selected Color</div>

                                            <div className="color-value">
                                                {watch("colour") || "#000000"}
                                            </div>
                                        </div>

                                        {/* Preview */}
                                        <div className="text-center">
                                            <div className="color-subtext">Preview</div>

                                            <div
                                                className="color-preview"
                                                style={{
                                                    backgroundColor: watch("colour") || "#000000",
                                                }}
                                            />
                                        </div>
                                    </div>

                                    {/* Error */}
                                    {errors.colour && (
                                        <p className="mt-2 color-error">
                                            {errors.colour.message}
                                        </p>
                                    )}
                                </div>


                                <div className="mb-3">
                                    <label className="form-label">
                                        Alert Message <span className="text-danger">*</span>
                                    </label>
                                    <textarea
                                        id="alert_message"
                                        placeholder="Enter alert message..."
                                        name='alert_message'
                                        {...register('alert_message')}
                                        className="description-input"
                                    />
                                    {errors.alert_message && (
                                        <p className="mt-1" style={{ color: "#d93025", fontFamily: "revert", marginLeft: '1%' }}>
                                            {errors.alert_message.message}
                                        </p>
                                    )}
                                </div>

                                <div className="mb-3">
                                    <label className="form-label">
                                        Status <span className="text-danger">*</span>
                                    </label>
                                    <select
                                        id="status"
                                        name="status"
                                        {...register('status')}
                                        className="custom-select"
                                    >
                                        <option value="">Select status</option>
                                        <option value="Active">Active</option>
                                        <option value="Inactive">Inactive</option>
                                    </select>
                                    {errors.status && (
                                        <p className="mt-2" style={{ color: "#d93025", fontFamily: "revert", marginLeft: '1%' }}>
                                            {errors.status.message}
                                        </p>
                                    )}

                                </div>


                                {/* <div className="status-field">
                                    <label className="status-label">
                                        {watch("status") === "active" ? "Active" : "Inactive"}
                                    </label>

                                    <div className="status-row">
                                        <label className="toggle">
                                            <input
                                                type="checkbox"
                                                className="toggle-input"
                                                checked={watch("status") === "active"}
                                                onChange={(e) =>
                                                    setValue("status", e.target.checked ? "active" : "inactive", {
                                                        shouldValidate: true,
                                                    })
                                                }
                                            />
                                            <span className="toggle-slider"></span>
                                        </label>

                                        <span className="status-text">
                                            Status is visible and usable immediately
                                        </span>
                                    </div>

                                    <input type="hidden" {...register("status", { required: true })} />

                                    {errors.status && (
                                        <p className="status-error">Status is required</p>
                                    )}
                                </div> */}

                                <div className="d-flex gap-2 mt-4">
                                    <button type="submit" className="btn btn-primary">
                                        {mode === "add" ? "Add Status" : "Update Status"}
                                    </button>

                                    {mode === "add" && (
                                        <button type="button" className="btn btn-secondary" onClick={resetButton}>
                                            Reset
                                        </button>
                                    )}
                                </div>

                            </form>
                        </div>
                    </div>

                    {/* Backdrop */}
                    <div className="offcanvas-backdrop fade show" onClick={onClose}></div>

                </>
            }
        </div>

    );
};

export default ManageCallStatus;